module.exports = __webpack_public_path__ + "static/media/carrot.69d526d9.jpg";